module.exports = __webpack_public_path__ + "img/slide11.46cb9651.png";